import { RouteNames } from '../constants/routes';

export type RouteToPageNameMap = Record<RouteNames, string>;
